/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductDto } from '../../models/backend-advanced-product-dto';
import { BackendAdvancedProductRequestDto } from '../../models/backend-advanced-product-request-dto';

export interface SalesAdvancedProductsUpdate$FormData$Params {
  id: number;
  body?: BackendAdvancedProductRequestDto;
}

export function salesAdvancedProductsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductDto>;
    }),
  );
}

salesAdvancedProductsUpdate$FormData.PATH = '/api/sales/advanced-products/{id}/';
